import { useEffect, useState } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaPinterestP,
  FaTwitter,
} from "react-icons/fa";
import { IoMdHeart } from "react-icons/io";
import { IoHeartOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Rating } from "react-simple-star-rating";
import cartImage from "../../assets/png/Rectangle.png";
import {
  addToCart,
  setAddToCartLoading,
} from "../../redux/slices/cart/cartSlice";
import { saveFavorite } from "../../redux/slices/favorite/favoriteSlice";
import { dispatch, RootState } from "../../redux/store";

const ProductInfo = ({
  id,
  setQty,
  qty,
  variant,
  setModal,
}: {
  id: any;
  setQty: (qty: number) => void;
  qty: number;
  variant: any;
  setModal?: any;
}) => {
  console.log("🚀 ~ variant:", variant, qty);
  const { product, isProductLoading } = useSelector(
    (state: RootState) => state.product
  );
  const { favorites } = useSelector((state: any) => state.favorite);
  const { addToCartLoading } = useSelector((state: any) => state.cart);

  const [isFavorited, setIsFavorited] = useState(
    favorites?.some((favorite: any) => favorite.productResponses[0].id === id)
  );
  const [inStock, setInStock] = useState(false);
  const [selectedDiscount, setSelectedDiscount] = useState<any>(
    variant?.discount ? variant?.discountResponses[0] : null
  );
  const [activeIcon, setActiveIcon] = useState<string | null>(null);

  useEffect(() => {
    dispatch(setAddToCartLoading(false));
    setInStock(product?.totalQuantity > 0);
  }, [favorites, id, product]);

  const handleQtyChange = (type: "increment" | "decrement") => {
    if (type === "decrement" && qty > 1) setQty(qty - 1);
    if (type === "increment" && qty < product.totalQuantity) {
      setQty(qty + 1);
    }
  };

  const isAddToCartDisabled = qty === 0 || qty > variant.quantity;
  const handleFavoriteToggle = () => {
    dispatch(saveFavorite({ productId: id }));
  };

  const [showCartModal, setShowCartModal] = useState(false);

  if (isProductLoading) {
    return <div>Loading</div>;
  }
  if (!product) {
    return <div>Error: Product details not available</div>;
  }

  function handleAddToCart() {
    console.log("🚀 ~ handleAddToCart ~ variant:", variant);
    dispatch(
      addToCart({
        variableId: product?.id,
        quantity: qty,
        sellingPrice: product?.sellingPrice,
        sellingPriceWithTax: product?.sellingPriceWithTax,
        variable: variant,
        discountId: variant?.discount && selectedDiscount?.id,
      })
    ).then((i) => {
      if (i && i.success) {
        if (!setModal) {
          setShowCartModal(true);
        } else {
          setModal(false);
        }
      }
    });
  }

  return (
    <div className="w-full lg:flex-grow flex-col py-1 px-4 relative container mx-auto">
      <div className="flex flex-col gap-4">
        {/* Product Name and Stock Status */}
        <div className="flex items-center gap-3">
          <h1 className="text-3xl font-semibold text-gray-900">
            {product.name} {}
          </h1>
          {!inStock && (
            <span
              className={`rounded-md text-xs md:text-sm w-fit font-medium shadow-md px-1 py-1 text-nowrap ${
                inStock
                  ? "bg-green-200 text-[green-700]"
                  : "bg-red-200 text-red-700"
              }`}
            >
              {inStock ? "In Stock" : "Out of Stock"}
            </span>
          )}
        </div>

        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-6">
            {product.avgRating ? (
              <div className="flex items-center gap-2">
                <Rating
                  initialValue={product.avgRating}
                  size={16}
                  readonly
                  SVGclassName="inline-block"
                />
                <span className="text-[14px] text-[#666666] font-Poppins  mt-1">
                  {product.reviewResponses.length}{" "}
                  {product.reviews > 1 ? "Reviews" : "Review"}
                </span>
              </div>
            ) : (
              <span className="text-xs text-[#666666]">No ratings yet!</span>
            )}
            <div className="flex items-center gap-2 text-sm">
              <span className="font-bold text-[#333333] mt-1 text-[14px] leading-[21px]">
                Tax:
              </span>
              <span className="text-[#666666] mt-1">
                {product.taxResponse.taxPercentage}%
              </span>
            </div>
          </div>

          {/* Pricing */}
          <div className="flex items-center gap-3 text-xl text-gray-800">
            <span
              className="text-[#2C742F] font-Poppins font-bold"
              style={{
                fontSize: "24px",
                lineHeight: "36px",
              }}
            >
              £
              {product?.discount &&
              (selectedDiscount?.discountType === "BUY_ONE_DISCOUNT" ||
                selectedDiscount?.discountType === "BUY_TWO_OR_MORE_DISCOUNT")
                ? product?.discountPrice
                : product?.sellingPriceWithTax}
            </span>
            {variant ? (
              variant?.discount &&
              (selectedDiscount?.discountType === "BUY_ONE_DISCOUNT" ||
                selectedDiscount?.discountType ===
                  "BUY_TWO_OR_MORE_DISCOUNT") ? (
                <span className="line-through self-start text-[#B3B3B3] text-xs md:text-sm">
                  <div className="line-through font-semibold text-[#B3B3B3] text-xs md:text-sm">
                    £{product?.sellingPriceWithTax}
                  </div>
                </span>
              ) : (
                variant?.discount &&
                (selectedDiscount?.discountType === "BUY_ONE_GET_ONE" ||
                  selectedDiscount?.discountType ===
                    "BUY_ONE_GET_OTHER_ONE") && (
                  <span className=" text-[#B3B3B3] text-xs md:text-sm">
                    {selectedDiscount?.discountType === "BUY_ONE_GET_ONE"
                      ? `Buy one Get one for free`
                      : `Get ${
                          selectedDiscount?.freeProductVariableResponse?.name ??
                          ""
                        } for free`}
                  </span>
                )
              )
            ) : (
              <></>
            )}

            {product ? (
              product?.discount &&
              (selectedDiscount?.discountType === "BUY_ONE_DISCOUNT" ||
                selectedDiscount?.discountType ===
                  "BUY_TWO_OR_MORE_DISCOUNT") ? (
                <span className=" py-1 px-2 bg-red-600 rounded-full text-[#fff] text-sm md:text-md">
                  <div className="font-semibold">
                    {(
                      ((product?.sellingPriceWithTax - product?.discountPrice) /
                        product?.sellingPriceWithTax) *
                      100
                    ).toFixed(0)}
                    % OFF
                  </div>
                </span>
              ) : (
                <></>
              )
            ) : (
              <></>
            )}
          </div>
        </div>
        {variant?.discount && (
          <>
            <div className="text-xs text-[#B3B3B3]">Select a discount</div>
            <div className="grid grid-cols-2 gap-2 md:grid-cols-3 w-full ">
              {product.discountResponses.map((discount: any) => (
                <div
                  key={discount.id}
                  className={`text-sm  font-semibold px-4 py-2 flex justify-center items-center cursor-pointer rounded-full ${
                    selectedDiscount?.id === discount.id
                      ? "bg-[#00B207] text-white"
                      : "bg-gray-100"
                  } hover:bg-gray-200 active:bg-gray-300`}
                  onClick={() => setSelectedDiscount(discount)}
                >
                  {discount.discountName}
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      <hr className="my-4 border-gray-300" />

      <div className="mt-4">
        <div className="mt-4">
          <div className="text-sm text-[#808080] mt-4 font-Poppins text-[14px] leading-[21px] font-weight: 400 ">
            {product.brandResponse && product.brandResponse.description
              ? product.brandResponse.description
              : "Description not available"}
          </div>
        </div>
      </div>

      <hr className="my-4 border-gray-300" />

      <div className="mt-4 flex flex-col md:flex-row items-center gap-4">
        <div className="flex items-center gap-1 justify-between w-full md:w-[124px] md:h-[50px] rounded-[170px] border border-gray-300 p-[4px] md:p-[8px] bg-white">
          <button
            onClick={() => handleQtyChange("decrement")}
            className={`${
              qty === 1 && "cursor-not-allowed opacity-50"
            }  h-[34px] w-[34px]  flex justify-center items-center rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 transition-all duration-300`}
          >
            -
          </button>
          <div className="flex justify-center items-center text-xl font-medium text-gray-800">
            {qty}
          </div>
          <button
            onClick={() => handleQtyChange("increment")}
            className={`h-[34px] transition-all w-[34px] ${
              isAddToCartDisabled && "cursor-not-allowed opacity-50"
            } flex justify-center items-center rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 transition-all duration-300`}
          >
            +
          </button>
        </div>
        <div className="flex gap-2 w-full md:w-fit">
          <button
            disabled={addToCartLoading || isAddToCartDisabled}
            onClick={() => handleAddToCart()}
            className={`${
              addToCartLoading && "cursor-not-allowed opacity-50"
            } flex-1 flex flex-grow items-center text-nowrap justify-center gap-2 py-2 px-4 hover:opacity-70  bg-[#00B207] text-white font-semibold text-[16px] leading-[19.2px] rounded-full hover:bg-[#00B207] active:scale-95 active:opacity-80 transition-all duration-300`}
          >
            Add to Cart
            <img src={cartImage} alt="Cart" className="h-5 w-5" />
          </button>
          {/* Favorite Button */}
          <div
            onClick={(e) => {
              e.stopPropagation();
              handleFavoriteToggle();
            }}
            className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 cursor-pointer transition-all duration-300 hover:scale-105 active:scale-95 active:opacity-80"
          >
            {favorites?.some(
              (favorite: any) => favorite.productResponses[0].id === id
            ) ? (
              <IoMdHeart size={20} className="text-green-600" />
            ) : (
              <IoHeartOutline size={20} className="text-gray-500" />
            )}
          </div>
        </div>
      </div>

      <hr className="my-2 border-t-1 border-gray-300" />
      <div className=" text-[#808080] mt-4 font-Poppins text-[14px] leading-[21px] font-weight: 400 ">
        <p className="text-lg font-semibold mb-2">
          <span className="text-[#1A1A1A] leading-[21px] font-weight: 500 font-Poppins">
            Category:
          </span>
          <span className="text-[#808080] text-[14px] font-weight: 400 ml-2">
            {product.categoryResponse.name}
          </span>
        </p>
      </div>
    </div>
  );
};

export default ProductInfo;
